module.exports = __webpack_public_path__ + "img/logo.6331b847.svg";